import { createFileRoute } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { DocumentTitle } from "@/components";
import { BuyerListPage } from "@/modules/user/pages/buyer-list-page";
import { requireAuthAndPermission } from "@/utils";

const buyersListSortEnum = z.enum(["newest", "oldest"]);

const buyersListSearchSchema = z.object({
  q: fallback(z.string(), "").default(""),
  page: fallback(z.number(), 1).default(1),
  sort: fallback(buyersListSortEnum, "newest").default("newest")
});

export const Route = createFileRoute("/users/buyers/")({
  validateSearch: zodValidator(buyersListSearchSchema),
  beforeLoad: requireAuthAndPermission,
  component: () => (
    <>
      <DocumentTitle
        title="Buyers"
        description="View and manage buyer accounts on the LAMPU Marketplace."
      />
      <BuyerListPage />
    </>
  )
});
